module.exports = __webpack_public_path__ + "static/img/41.59bbea1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/41.png
// module id = 4EeP
// module chunks = 1